const manageDetail = {
    namespaced : true,
    state : {
        loading: false,
        dataWrongAnswer: {},
        showWrongAnswer: false,
    },
    mutations : {
        setLoading(state, payload) {
            state.loading = payload;
        },
        setDataWrongAnswer(state, payload) {
            state.dataWrongAnswer = payload;
        },
        setShowWrongAnswer(state, payload) {
            state.showWrongAnswer = payload;
        }
    },
    getters : {
        getLoading (state) {
            return state.loading;
        },
        getShowWrongAnswer(state) {
            return state.showWrongAnswer;
        },
        getDataWrongAnswer(state) {
            return state.dataWrongAnswer;
        }
    }
};

export default manageDetail;


// WEBPACK FOOTER //
// ./src/stores/modules/manageDetail.js